import React from 'react';
import { EnumTablePosition } from 'src/types/common/common';
import { Button } from 'src/components/Antd';
import ProductSelection from 'src/constrains/ProductSelectionNoPagination/GeneralSalesChannelProductSelection';
import { customColumns, filterList, customerConvertQuery } from './config';
// import { randomNumber } from 'src/tools/helper';
import ProductItemsTable from './ProductItemsTable';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
import { get } from 'lodash';

const widthDict = {
  productName: { minWidth: 221 },
  sku: { minWidth: 120 },
  qty: {
    width: 76,
  },
  listPrice: { width: 87 },
  discount: { width: 87 },
  sellingPrice: { width: 102 },
  action: { width: 70 },
};
//这个组件在createNewOrder中的products模块和order Detail中的additionalItems 中用到了，修改时需要注意，不要影响
const ProductsItems = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const {
    salesChannelUuid,
    value,
    addText,
    disabled,
    AdditionalUuid,
    createRequest,
    hideAddButton,
    onChange,
    showDelete,
    currency,
    keyUuid,
    filterList: _filterList,
    customerConvertQuery: _customerConvertQuery,
    initialSearchProps,
  } = props;
  const [visible, setVisible] = React.useState(false);
  const generateUniqueId = (product) => {
    return `${get(product, 'productUuid')}${get(
      product,
      'salesChannelProductUuid',
    )}${get(product, 'uuid')}`;
  };
  const extendColumns = (disabled) => [
    {
      title: getI18n(
        `allOrders.orderDetail.termsAndConditionConsent_columns_action_title`,
      ),
      key: 'action',
      default: true,
      position: EnumTablePosition.right,
      childGenerate: (text, record, index) =>
        ((value || []).length == 1 && AdditionalUuid) || disabled ? (
          <div className={css.disableDelete}>
            {getI18n(`allOrders.orderDetail.productItems_extendColumns_Delete`)}
          </div>
        ) : (
          <div
            className={css.delete}
            onClick={() => handleDelete(record, index)}>
            {getI18n(`allOrders.orderDetail.productItems_extendColumns_Delete`)}
          </div>
        ),
      ...widthDict['action'],
    },
  ];
  const handleDelete = (record, index) => {
    const _additionalItems = value.filter(
      (o, itemIndex) =>
        !(
          itemIndex == index &&
          o.uuid == record.uuid &&
          o.salesChannelProductUuid == record.salesChannelProductUuid &&
          o.productUuid == record.productUuid
        ),
    );
    if (onChange) onChange(_additionalItems);
  };

  const handleOnShow = () => {
    setVisible(true);
  };
  const handleOnCancel = () => {
    setVisible(false);
  };
  const handleDeleteAll = () => {
    if (onChange) onChange([]);
  };
  // const handleCustomAdd = (uuid, data) => {
  //   const _additionalItems = cloneDeep(value || []);
  //   _additionalItems.forEach((item) => {
  //     if (item.uuid === uuid) {
  //       item.virtualProductService = {};
  //       item.virtualProductService.virtualProductServiceItems = data;
  //     }
  //   });
  //   if (onChange) onChange(_additionalItems);
  // };
  const handleOnOk = (products) => {
    const productsClone = products.reduce((pre, now) => {
      if (now.children) {
        now.children.forEach((list) => {
          list.salesChannelProductUuid = now.uuid;
          list.productUuid = list.uuid;
          list.uuid = now.uuid;
          list.amount = 1;
          list[keyUuid || 'randomKey'] = generateUniqueId(list);
        });
        return pre.concat(now.children);
      } else {
        now.amount = 1;
        now.keyUuid = generateUniqueId(now);
        return pre.concat(now);
      }
    }, []);
    const newProducts = productsClone.map((i) => {
      const k = get(i, keyUuid);
      const ori = (value || []).find((o) => get(o, keyUuid) === k);
      return {
        ...i,
        amount: get(ori, 'amount') || get(i, 'amount'),
      };
    });
    // setAdditionalItems(productsClone);
    if (onChange) onChange(newProducts);
  };
  return (
    <div className={css.containerClassName}>
      {visible && (
        <ProductSelection
          initialSearchProps={initialSearchProps}
          withMultiCurrency={true}
          canSelectChildren
          selectedProducts={[]}
          onCancel={handleOnCancel}
          showCustomisation={true}
          visible={visible}
          salesChannelUuid={salesChannelUuid}
          onOk={handleOnOk}
          customQueryProps={{
            filters: _filterList || filterList,
            customerConvertQuery: (filter) => {
              const result = (_customerConvertQuery || customerConvertQuery)(
                filter,
              );
              if (currency) result.currencyCode = currency;
              return result;
            },
          }}
          customColumns={customColumns({ getI18n })}
        />
      )}
      {/* 这个组件在很多处都用到了，改动的时候需要注意，不要影响到 customisation */}
      <ProductItemsTable
        value={value}
        rowKey={keyUuid}
        onChange={onChange}
        disabled={disabled}
        extendColumns={extendColumns(disabled)}
        currency={currency}
      />
      {!hideAddButton && (
        <Button
          className={css.button}
          disabled={disabled || !salesChannelUuid}
          type='primary'
          onClick={handleOnShow}>
          {addText ||
            getI18n(
              `allOrders.orderDetail.productItems_extendColumns_return_add_btn`,
            )}
        </Button>
      )}
      {createRequest && (
        <Button
          disabled={disabled}
          className={css.button}
          type='primary'
          onClick={createRequest}>
          {AdditionalUuid
            ? getI18n(
                `allOrders.orderDetail.productItems_extendColumns_return_createRequest_save_btn`,
              )
            : getI18n(
                `allOrders.orderDetail.productItems_extendColumns_return_createRequest_CreateRequest_btn`,
              )}
        </Button>
      )}
      {showDelete && (
        <Button
          className={css.deleteButton}
          type='danger'
          disabled={disabled}
          ghost
          onClick={handleDeleteAll}>
          {getI18n(
            `allOrders.orderDetail.productItems_extendColumns_return_delete_btn`,
          )}
        </Button>
      )}
    </div>
  );
};

export default ProductsItems;
